var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.207 6.575a.5.5 0 01.38-.825h6.826a.5.5 0 01.38.825L8.38 10.557a.5.5 0 01-.76 0L4.207 6.575z",
    fill: "#8D92A1"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMjA3NDggNi41NzUzOUMzLjkyOTQ4IDYuMjUxMDYgNC4xNTk5MyA1Ljc1IDQuNTg3MTEgNS43NUwxMS40MTI5IDUuNzVDMTEuODQwMSA1Ljc1IDEyLjA3MDUgNi4yNTEwNiAxMS43OTI1IDYuNTc1NEw4LjM3OTYzIDEwLjU1NzFDOC4xODAwOCAxMC43ODk5IDcuODE5OTIgMTAuNzg5OSA3LjYyMDM3IDEwLjU1NzFMNC4yMDc0OCA2LjU3NTM5WiIgZmlsbD0iIzhEOTJBMSIvPgo8L3N2Zz4K";
export { SvgArrow as ReactComponent };